import request from '@/utils/request'

export function _get (url, data) {
  return request({
    url: url,
    method: 'get',
    params: data
  })
}

export function _post (url, data) {
  return request({
    url: url,
    method: 'post',
    data: data
  })
}

export function _put (url, data) {
  return request({
    url: url,
    method: 'put',
    data: data
  })
}

export function _exportword (url, data, vm) {
  return request({
    url: url,
    method: 'post',
    onUploadProgress: function (progressEvent) { //原生获取上传进度的事件
      if (progressEvent.lengthComputable) {
        //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
        //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
        var data = Math.floor((progressEvent.loaded / progressEvent.total) * 100)
        if (data === 100) {
          vm.$root.eventHub.$emit('getUploadProgress', 99)
        } else {
          vm.$root.eventHub.$emit('getUploadProgress', data)
        }

      }
    },
    data: data
  })
}
